/**
 * The path part of a navbar route. A cinematic route may carry a query
 * (`/tournament-detail?id=…`) while `usePathname()` never does, so comparing
 * the two raw strings leaves such an item permanently inactive.
 */
export const toPathname = (route: string): string => route.split(/[?#]/)[0]
